import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserNoticeBoardComponent } from './user-notice-board.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { PostCardComponent } from './components/post-card/post-card.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { CreateNoticeBoardPostsComponent } from './components/create-notice-board-posts/create-notice-board-posts.component';
import { ReportPostDialogComponent } from './components/report-post-dialog/report-post-dialog.component';
import { PostReportsComponent } from './components/post-reports/post-reports.component';
import { UserNoticeBoardRoutingModule } from './user-notice-board-routing.module';

const components = [
  UserNoticeBoardComponent,
  CreateNoticeBoardPostsComponent,
  PostCardComponent,
  ReportPostDialogComponent,
  PostReportsComponent,
];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    UserNoticeBoardRoutingModule,
    MaterialModule,
    ColorPickerModule,
  ],
  exports: [CommonModule, ...components],
})
export class UserNoticeBoardModule {}
